import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  ValidateDiscountCodeErrorResponse,
  ValidateDiscountCodeRequest,
  ValidateDiscountCodeSuccessResponse
} from './validateDiscountCode.types'

export const validateDiscountCodeApi = async (
  request: ValidateDiscountCodeRequest
): Promise<ValidateDiscountCodeSuccessResponse> => {
  const { code } = request

  const response = await configureRequest({
    url: urls.payments.validateDiscountCode,
    method: 'GET',
    params: {
      code
    },
    headers: {
      'X-User-Role': UserRole.shopper
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as ValidateDiscountCodeSuccessResponse
  } else {
    throw response as ValidateDiscountCodeErrorResponse
  }
}

export default validateDiscountCodeApi
